import { CustomSelectOption } from '@lfg/ui/components';
import { useEffect } from 'react';

import AdminSelect, { AdminSelectProps } from 'src/components/NodeSaleForm/AdminSelect';
import { systemFonts } from 'src/global/constants/font.constant';

interface FontSelectProps extends Omit<AdminSelectProps, 'options'> {}

export function FontSelect(props: FontSelectProps) {
  const { value, ...rest } = props;

  // Dynamically load fonts into the document head
  useEffect(() => {
    systemFonts.forEach(font => {
      const link = document.createElement('link');
      link.href = font.fontUrl;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    });
  }, []);

  return (
    <AdminSelect
      options={systemFonts.map(font => ({ value: font.fontName, label: font.fontName }))}
      value={value}
      menuItemProps={(option: CustomSelectOption) => ({
        sx: {
          fontFamily: option.value,
        },
      })}
      sx={{
        fontFamily: value as string,
      }}
      {...rest}
    />
  );
}
